import { render, staticRenderFns } from "./SpawnSectionsList.vue?vue&type=template&id=3d8f2190&lang=pug&"
import script from "./SpawnSectionsList.vue?vue&type=script&lang=js&"
export * from "./SpawnSectionsList.vue?vue&type=script&lang=js&"
import style0 from "./SpawnSectionsList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports